/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Terms_Imported_TermsInputs */



/**
* | output |
* | --- |
* | "Imported {count} terms" |
*
* @param {Knp_Terms_Imported_TermsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_imported_terms = /** @type {((inputs: Knp_Terms_Imported_TermsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Imported_TermsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Importation de ${i?.count} termes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Importierte ${i?.count} Begriffe`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Termini importati ${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импортированные термины ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Términos ${i?.count} importados`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入的${i?.count}条款`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`インポートされた${i?.count}用語`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आयातित ${i?.count} शर्तें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Termos importados ${i?.count}`)
	return /** @type {LocalizedString} */ (`Imported ${i?.count} terms`)
});